
import { inject, Injectable } from "@angular/core";
import { ApiService } from "./apiService";
import { IFormMetadata, ProcessSaveContainer, ProcessStepFormContainer, ProcessStepperContainer, RepositoryDataCollection } from "@tylertech/tyler-api-types";

/**
 * ProcessStepperService is a generated service implementation. Any edits will be overridden!
 */
@Injectable()
export class ProcessStepperService {
    private readonly $apiService = inject(ApiService);
    
    CanShowUnlockStepOption(pStepId: string): Promise<boolean> {
        return this.$apiService.sendAuth("IProcessStepperService/CanShowUnlockStepOption", pStepId);
    }
    ChildFormSave(packet: ProcessSaveContainer): Promise<RepositoryDataCollection> {
        return this.$apiService.sendAuth("IProcessStepperService/ChildFormSave", packet);
    }
    CompleteStep(packet: ProcessSaveContainer): Promise<RepositoryDataCollection> {
        return this.$apiService.sendAuth("IProcessStepperService/CompleteStep", packet);
    }
    GetPathToStep(pProcessStepId: string): Promise<string> {
        return this.$apiService.sendAuth("IProcessStepperService/GetPathToStep", pProcessStepId);
    }
    GetProcessStepper(processId: string): Promise<ProcessStepperContainer[]> {
        return this.$apiService.sendAuth("IProcessStepperService/GetProcessStepper", processId);
    }
    GetProcessTitle(processId: string): Promise<string> {
        return this.$apiService.sendAuth("IProcessStepperService/GetProcessTitle", processId);
    }
    GetProcessTitleForProcessStep(processStepId: string): Promise<string> {
        return this.$apiService.sendAuth("IProcessStepperService/GetProcessTitleForProcessStep", processStepId);
    }
    GetStepForm(processStepContainer: ProcessStepFormContainer): Promise<IFormMetadata> {
        return this.$apiService.sendAuth("IProcessStepperService/GetStepForm", processStepContainer);
    }
    UnlockStep(pStepId: string): Promise<void> {
        return this.$apiService.sendAuth("IProcessStepperService/UnlockStep", pStepId);
    }
}
